import KeywordsService from '../../services/KeywordsService';

export const namespaced = true;

export const state = {
  keywords: [],
};

export const mutations = {
  ADD_KEYWORD(state, keyword) {
    if (!state.keywords) {
      state.keywords = [];
    }
    state.keywords.push(keyword);
  },
  ADD_KEYWORDS(state, keywords) {
    if (!state.keywords) {
      state.keywords = [];
    }
    keywords.forEach(keyword => state.keywords.push(keyword));
  },
  REMOVE_KEYWORD(state, keywordId) {
    if (state.keywords && state.keywords.length > 0) {
      state.keywords = state.keywords.filter(keyword => keyword.id !== keywordId);
    }
  },
  SET_KEYWORDS(state, keywords) {
    state.keywords = keywords;
  },
};

export const actions = {
  getKeywords({ commit }) {
    return KeywordsService.getKeywords()
      .then(({ data }) => {
        commit('SET_KEYWORDS', data);
      });
  },
  createKeyword({ commit }, { language, word }) {
    return KeywordsService.create({
      language,
      word,
    })
      .then(({ data }) => {
        commit('ADD_KEYWORD', data);
        return data;
      });
  },
  createKeywords({ commit }, { language, keywords }) {
    if (Array.isArray(keywords)) {
      return KeywordsService.createBulk({
        language,
        keywords,
      })
        .then(({ data }) => {
          commit('ADD_KEYWORDS', data);
        });
    }
    const keywordValues = keywords.split(',')
      .map(value => value.trim())
      .filter(value => value.length > 1);
    return KeywordsService.createBulk({
      language,
      keywords: keywordValues,
    })
      .then(({ data }) => {
        commit('ADD_KEYWORDS', data);
      });
  },
  deleteKeyword({ commit }, keywordId) {
    return KeywordsService.delete(keywordId)
      .then(() => {
        commit('REMOVE_KEYWORD', keywordId);
      });
  },
};

export const getters = {
  sortAlpha(state) {
    return state.keywords.sort((k1, k2) => {
      if (k1 > k2) {
        return 1;
      }
      if (k2 > k1) {
        return -1;
      }
      return 0;
    });
  },
  filterKeywords: (state, getters) => ({ word }) => {
    let filteredKeywords = getters.sortAlpha;
    if (word && word.length > 0) {
      filteredKeywords = filteredKeywords.filter(keyword => keyword.word.toLowerCase()
        .includes(word.toLowerCase()));
    }
    return filteredKeywords;
  },
};
